export const isRequired = (fieldName: any) => `O campo ${fieldName} é obrigatório`;

export const maxLength = (fieldName: any, length: any) =>
  `O campo ${fieldName} deve ter no máximo ${length} caracteres`;

export const minLength = (fieldName: any, length: any) =>
  `O campo ${fieldName} deve ter pelo menos ${length} caracteres`;

export const arrayMinLength = (fieldName: any, length: any) =>
  `O campo ${fieldName} deve ter pelo menos ${length} item(s)`;

export const arrayMaxLength = (fieldName: any, length: any) =>
  `O campo ${fieldName} deve ter no máximo ${length} item(s)`;

export const isEmail = (fieldName: any) => `O campo ${fieldName} não é um email válido`;

export const isUrl = (fieldName: any) =>
  `O campo ${fieldName} não é uma url válida, lembre-se de utilizar http:// ou https:// antes do link`;

export const minimun = (fieldName: any, min: any) => `O valor de ${fieldName} tem que ser no mínimo ${min}`;

export const maximum = (fieldName: any, max: any) => `O valor de ${fieldName} tem que ser no máximo ${max}`;
